import React, { useRef, useEffect } from 'react';

// import React from 'react';
import videoBg from '../assets/windmills.mp4'; // Adjust path based on your structure

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.65;
    }
}, []);
  return (
    <section style={{
      position: 'relative',
      height: '80vh',
      overflow: 'hidden',
      color: 'white'
    }}>
      {/* Background video */}
      <video
        ref={videoRef}
        src={videoBg}
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          top: 0,
          left: 0,
          zIndex: 0
        }}
      />

      {/* Dark overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))',
        zIndex: 1
      }} />

      {/* Content on top */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '0 5%',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '3rem',
          marginBottom: '20px',
          fontWeight: 700
        }}>
          Independent Energy Insights, Grounded in System Expertise
        </h1>
        <p style={{
          fontSize: '1.2rem',
          maxWidth: '900px',
          lineHeight: 1.6,
          marginBottom: '40px'
        }}>
          At Peerwatt, we don't just model energy systems; we understand them deeply.
          We deliver objective, data-driven consulting across electricity, gas, and hydrogen markets:
          with no ties, no bias, just clarity.
        </p>
        <a
          href="#contact"
          style={{
            backgroundColor: '#1a73e8',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: 'pointer',
            fontWeight: 'bold',
            textDecoration: 'none',
            scrollBehavior: 'smooth'
          }}
        >
          Let’s Talk
        </a>
      </div>
    </section>
  );
};

export default Hero;
